"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _utils = require('shared/store/utils');
var _helpers = require('shared/actions/helpers');













// Lane B's scheduled-message commands (#889). Each takes its request object
// as is, so a later optional list of files rides along without reshaping.
const listScheduledMessagesActions = _utils.createAsyncActions('ListScheduledMessages')
const scheduleMessageActions = _utils.createAsyncActions('ScheduleMessage')
const editScheduledMessageActions = _utils.createAsyncActions('EditScheduledMessage')
const sendScheduledMessageNowActions = _utils.createAsyncActions('SendScheduledMessageNow')
const retryScheduledMessageActions = _utils.createAsyncActions('RetryScheduledMessage')
const cancelScheduledMessageActions = _utils.createAsyncActions('CancelScheduledMessage')
const dismissScheduledMessageActions = _utils.createAsyncActions('DismissScheduledMessage')
// Cancel hides the bubble at once and sends the command only once Undo has
// run out (shared/services/scheduledCancels); Undo shows it again.
const hideScheduledMessageAction = _utils.createAction.call(void 0, 
  'HIDE_SCHEDULED_MESSAGE', (key) => ({ payload: key }),
)
const unhideScheduledMessageAction = _utils.createAction.call(void 0, 
  'UNHIDE_SCHEDULED_MESSAGE', (key) => ({ payload: key }),
)
// The zone the user schedules in. One read back from the device's storage
// (fromStorage) gives way to a zone picked in the meantime.
const setScheduleTimeZoneAction = _utils.createAction.call(void 0, 
  'SET_SCHEDULE_TIME_ZONE',
  (timeZone, fromStorage = false) => ({ payload: { timeZone, fromStorage } }),
)

 const actionCreators = {
  listScheduledMessagesActions,
  scheduleMessageActions,
  editScheduledMessageActions,
  sendScheduledMessageNowActions,
  retryScheduledMessageActions,
  cancelScheduledMessageActions,
  dismissScheduledMessageActions,
  hideScheduledMessageAction,
  unhideScheduledMessageAction,
  setScheduleTimeZoneAction,
}; exports.actionCreators = actionCreators

// The list's response doesn't name its chat; the meta does, for the reducer,
// with a number per request so the reducer can tell an older reply (ignored)
// from the latest, and keep rows written while the latest was in flight.
let lastListRequest = 0
const listScheduledMessages = (ConversationKey) => {
  lastListRequest += 1
  return _helpers.wsCommand(
    'ListScheduledMessages', listScheduledMessagesActions, { ConversationKey }, { ConversationKey, ListRequest: lastListRequest },
  )
}

const scheduleMessage = (req) =>
  _helpers.wsCommand('ScheduleMessage', scheduleMessageActions, req, null)

const editScheduledMessage = (req) =>
  _helpers.wsCommand('EditScheduledMessage', editScheduledMessageActions, req, null)

const sendScheduledMessageNow = (req) =>
  _helpers.wsCommand('SendScheduledMessageNow', sendScheduledMessageNowActions, req, null)

// Sends a failed row again now, as its author.
const retryScheduledMessage = (req) =>
  _helpers.wsCommand('RetryScheduledMessage', retryScheduledMessageActions, req, null)

const cancelScheduledMessage = (req) =>
  _helpers.wsCommand('CancelScheduledMessage', cancelScheduledMessageActions, req, null)

const dismissScheduledMessage = (req) =>
  _helpers.wsCommand('DismissScheduledMessage', dismissScheduledMessageActions, req, null)

exports. default = {
  listScheduledMessages,
  scheduleMessage,
  editScheduledMessage,
  sendScheduledMessageNow,
  retryScheduledMessage,
  cancelScheduledMessage,
  dismissScheduledMessage,
}
